// extracted by mini-css-extract-plugin
module.exports = {"CarouselBanner":"CarouselBanner_CarouselBanner__2OE85","CarouselItem":"CarouselBanner_CarouselItem__2DDWG","CarouselCaption":"CarouselBanner_CarouselCaption__1hIgV"};